import { HeaderBase } from '../HeaderBase';
import { MatchaLogoButton } from '../MatchaLogoButton';

export function LegalHeader() {
  return (
    <HeaderBase className="flex items-center justify-start">
      <div className="flex items-center">
        <MatchaLogoButton />
      </div>
    </HeaderBase>
  );
}
